export default __webpack_public_path__ + "assets/howWork5.eebae30e.png";